module.exports = __webpack_public_path__ + "img/icon-danger.e399ef2b.svg";